import React from 'react'

const IconClosePlain = ({ fill = 'white' }) => {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.48589 13.5964L0.402344 12.5128L5.91484 7.00034L0.402344 1.48784L1.48589 0.404297L6.99838 5.9168L12.5109 0.404297L13.5944 1.48784L8.08193 7.00034L13.5944 12.5128L12.5109 13.5964L6.99838 8.08388L1.48589 13.5964Z'
        fill={fill}
      />
    </svg>
  )
}

export default IconClosePlain
